import {
  APIPath,
  Entry,
  EntryVersion,
  PageResponse,
  GetStoryResult,
} from '@/cms';
import { apiCallStrapi } from '@/utils/fetch';

interface GetStoryProps {
  slug?: string;
  documentId?: string;
  apiPath: APIPath;
  status?: EntryVersion;
  tags?: string[];
}
export async function getStory<T extends Entry = Entry>({
  slug,
  documentId,
  apiPath,
  status,
  tags,
}: GetStoryProps): Promise<GetStoryResult<T>> {
  if (!slug && !documentId) {
    throw new Error('slug or documentId is required');
  }

  const filters = {
    ...(slug && { slug: { $eq: slug } }),
    ...(documentId && { documentId: { $eq: documentId } }),
  };

  const response = await apiCallStrapi<PageResponse<T>>({
    path: apiPath,
    query: {
      pLevel: 'deep',
      filters,
      pagination: {
        pageSize: 1,
      },
    },
    method: 'GET',
    status,
    next: {
      tags: tags,
    },
    fetchOptions: {
      cache: 'force-cache',
    },
  });

  const data = response?.data;
  const meta = response?.meta;

  return {
    data: Array.isArray(data) ? data[0] : data,
    meta: meta ?? null,
  };
}
